import { render, staticRenderFns } from "./ModalFastRegisterTomador.vue?vue&type=template&id=94a2679a"
import script from "./ModalFastRegisterTomador.vue?vue&type=script&lang=js"
export * from "./ModalFastRegisterTomador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports